import { render, staticRenderFns } from "./platform_config.vue?vue&type=template&id=73316b45&scoped=true"
import script from "./platform_config.vue?vue&type=script&lang=js"
export * from "./platform_config.vue?vue&type=script&lang=js"
import style0 from "./platform_config.vue?vue&type=style&index=0&id=73316b45&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73316b45",
  null
  
)

export default component.exports